import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BusinessHeader } from '@/components/public/shared/BusinessHeader';
import { ArrowLeft, Building2 } from 'lucide-react';
import { type BusinessData } from '@/components/public/adventures/utils/customAdventureUtils';

interface StickyBusinessHeaderProps {
  businessData: BusinessData | null;
  businessLoading: boolean;
  businessId: string | undefined;
}

export const StickyBusinessHeader = ({
  businessData,
  businessLoading,
  businessId
}: StickyBusinessHeaderProps) => {
  const { t } = useTranslation('public', { keyPrefix: 'customAdventures' });
  const navigate = useNavigate();

  return (
    <div className="sticky top-[calc(4rem+env(safe-area-inset-top,0px))] z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 py-2">
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-between gap-4"
        >
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <Button
              onClick={() => navigate(-1)}
              variant="ghost"
              size="sm"
              className="text-gray-600 hover:text-gray-900 p-2"
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div className="min-w-0 flex-1">
              <BusinessHeader businessData={businessData} businessLoading={businessLoading} />
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              onClick={() => navigate(`/business/${businessId}`)}
              variant="outline"
              size="sm"
              className="text-gray-600 hover:text-gray-900 border-gray-300"
            >
              <Building2 className="w-4 h-4 mr-1" />
              {t('navigation.viewProfile')}
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
